import React from 'react';
export default function TickIconContainer({src}) {
    return (
        <div className='tick-icon-container'>
          <img className='tick-icon' src={src} alt="selected" />
        </div>
    );
}